var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m9.667 1.273-.94-.94L5 4.06 1.274.333l-.94.94L4.06 5 .333 8.726l.94.94L5 5.94l3.727 3.726.94-.94L5.94 5z"
  })));
};
export { SvgCrossIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/CrossIcon.58b63d01.svg";